// extracted by mini-css-extract-plugin
export default {"magasins":"magasins_magasins__XHlRT","content":"magasins_content__+6vRY"};